import styled from 'styled-components'
import { mediaQ, fontSizeResponsive } from '../../theme/mixins'

export const DailyBalanceTile = styled.div`
  max-width: 20vw;
  width: 20vw;
  padding: 0 30px;
  box-sizing: border-box;
  margin-left: 5vw;

  ${mediaQ(
    'mobileAll',
    'width: 90vw;max-width: 90vw; padding-bottom: 10px; margin-left: unset;'
  )}

  ${mediaQ('oldIpads', 'width: 45vw;max-width: 45vw;margin-left: 10px;')}
  ${mediaQ('ipad9', 'width: 45vw;max-width: 45vw;margin-left: 10px;')}
  ${mediaQ('ipad10', 'width: 45vw;max-width: 45vw;margin-left: 10px;')}
`

export const MealsListTile = styled.div`
  max-width: 25vw;
  width: 25vw;
  padding: 0 30px;
  box-sizing: border-box;

  ${mediaQ('mobileAll', 'width: 90vw;max-width: 90vw; padding: 0')}

  ${mediaQ('oldIpads', 'width: 45vw;max-width: 45vw;margin-left: 10px;')}
  ${mediaQ('ipad9', 'width: 45vw;max-width: 45vw;margin-left: 10px;')}
  ${mediaQ('ipad10', 'width: 45vw;max-width: 45vw;margin-left: 10px;')}
`
